import { CheckCircle, Info } from "@piiqtechnologies/svg-icons";
import { PeekAlert, PeekBox, PeekCircularProgress, PeekDivider, PeekTypography } from "@piiqtechnologies/ui-components";
import React from "react";
import { useIntl } from "react-intl";
import { ReportLabels } from "./DownloadAnalyticsFormConfig";
import messages from "./messages.i18n";
const DownloadAnalyticsProgress = ({ selectedReports, finishedReports }) => {
    const intl = useIntl();
    function getReportStatus(reportType) {
        if (!finishedReports || !Object.keys(finishedReports).includes(reportType)) {
            return "in_progress";
        }
        return finishedReports[reportType] ? "success" : "failed";
    }
    return (React.createElement(PeekBox, { px: 2, pb: 2 },
        React.createElement(PeekAlert, { icon: React.createElement(Info, null) },
            React.createElement(PeekTypography, null, intl.formatMessage(messages.downloadTimeDisclaimer))),
        selectedReports.map((reportType, index) => {
            const status = getReportStatus(reportType);
            const isInProgress = status === "in_progress";
            const isFailed = status === "failed";
            const isSuccess = status === "success";
            return (React.createElement(React.Fragment, null,
                index > 0 && React.createElement(PeekDivider, { light: true }),
                React.createElement(PeekBox, { p: 1, mt: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" },
                    React.createElement(PeekTypography, { variant: "h5", fontWeight: "fontWeightMedium" }, intl.formatMessage(ReportLabels[reportType])),
                    isInProgress && (React.createElement(PeekBox, null,
                        React.createElement(PeekTypography, { variant: "body1", fontStyle: "italic" }, intl.formatMessage(messages.downloading)),
                        React.createElement(PeekCircularProgress, { color: "secondary", size: 16 }))),
                    isFailed && (React.createElement(PeekTypography, { color: "error.main" }, intl.formatMessage(messages.downloadFailed))),
                    isSuccess && (React.createElement(PeekTypography, { color: "success.main", fontSize: 16 },
                        React.createElement(CheckCircle, null))))));
        })));
};
export default DownloadAnalyticsProgress;
